import {IPNSSearch} from '@portal-ng/PNSModels/PNSSearch.model';

export interface IPNSCodeSearch extends IPNSSearch {
  active?: boolean;
  category?: string;
}
